export default __webpack_public_path__ + "static/Accent Orb-8370e441ba5fc61d4bc02dc4c730c621.svg";